module.exports = __webpack_public_path__ + "static/Q6Answer4_Tourists_vidarNordli-c6d6ce61b163c524b689ce93c3d05d18.jpg";